/* ============================================================================
   FACHA POSTA - Extras de la home.
     1. Contador del CYBER FACHA (barra de arriba)
     2. Carrusel de "Comprá por Categoría" que se mueve solo
   ========================================================================== */
(function () {
  'use strict';

  var editor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- 1. CONTADOR DEL CYBER ----------
     Cada tick se recalcula contra Date.now(), NO se resta 1 al valor anterior: los
     navegadores estrangulan setInterval en pestanas de fondo y iOS lo congela con la
     pantalla apagada, asi que un contador acumulativo vuelve atrasado. */
  function contador() {
    var barra = document.querySelector('.fp-cyber');
    if (!barra) return;
    var reloj = barra.querySelector('[data-fp-reloj]');
    var fin = Date.parse(barra.getAttribute('data-fin'));
    if (!reloj || isNaN(fin)) return;

    var tic = null;

    function vencida() {
      /* NO se esconde la barra: evaporarla con el visitante a mitad de scroll sube todo
         el contenido de golpe. Se cambia el mensaje y se respeta el alto. */
      var texto = barra.getAttribute('data-fin-texto') || '';
      var gancho = barra.querySelector('.fp-cyber__gancho');
      var sep = barra.querySelector('.fp-cyber__sep');
      var marca = barra.querySelector('.fp-cyber__marca');
      if (gancho) gancho.hidden = true;
      if (sep) sep.hidden = true;
      if (marca && texto) { marca.textContent = texto; marca.style.whiteSpace = 'normal'; }
      reloj.hidden = true;
      barra.removeAttribute('href');
      if (tic) { clearInterval(tic); tic = null; }
    }

    function pintar() {
      var falta = fin - Date.now();
      if (falta <= 0) { vencida(); return; }
      var s = Math.floor(falta / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var g = s % 60;
      function dd(n) { return n < 10 ? '0' + n : String(n); }
      reloj.textContent = d > 0
        ? d + 'd ' + dd(h) + ':' + dd(m) + ':' + dd(g)
        : dd(h) + ':' + dd(m) + ':' + dd(g);
    }

    pintar();
    tic = setInterval(pintar, 1000);
    /* Al volver de una pestana de fondo se repinta enseguida, sin esperar el tick. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') pintar();
    });
  }

  /* ---------- 2. CARRUSEL DE CATEGORIAS QUE SE MUEVE SOLO ----------
     NO se usa el metodo next() del tema: select() clampea el indice con
     Math.min(totalPages, indice) (theme.js:1103) y con 6 categorias en 5 columnas
     totalPages da 2, asi que el carrusel se traba en la tercera tarjeta.
     Se mueve por geometria sobre el propio scroller, que es lo que el componente
     entiende igual (es un overflow nativo con scroll-snap, no transforms). */
  var PAUSA = 3800;

  function carrusel() {
    /* El id real es #shopify-section-template--<id>__collection-list, asi que se
       busca por la clase que declara el schema del section, que no cambia. */
    var seccion = document.querySelector('.shopify-section--collection-list');
    if (!seccion) return;
    var carril = seccion.querySelector('scroll-carousel');
    if (!carril) return;

    /* Con una sola pantalla de contenido no hay nada que rotar. */
    if (carril.scrollWidth <= carril.clientWidth + 4) return;

    var tic = null, enPantalla = false, tocado = false;

    function paso() {
      /* itemOffset lo calcula el componente: respeta gap y ancho real de la tarjeta. */
      var salto = carril.itemOffset || carril.clientWidth;
      var tope = carril.scrollWidth - carril.clientWidth;
      var hoy = Math.abs(carril.scrollLeft);       // en RTL scrollLeft es negativo
      var destino = (hoy + salto >= tope - 2) ? 0 : Math.min(hoy + salto, tope);
      carril.scrollTo({ left: destino, behavior: destino === 0 ? 'auto' : 'smooth' });
      /* Al volver al principio de golpe, se avisa para que el tema recalcule si los
         botones van habilitados: sus listeners de scroll van con rAF y en algunos
         casos no llegan a correr. */
      if (destino === 0) carril.dispatchEvent(new Event('scroll'));
    }

    function arrancar() {
      if (tic || tocado || !enPantalla) return;
      if (document.visibilityState !== 'visible') return;
      tic = setInterval(paso, PAUSA);
    }
    function frenar() { if (tic) { clearInterval(tic); tic = null; } }

    /* Solo corre con la seccion en pantalla: si no, el visitante vuelve y se encuentra
       el carrusel en una posicion que nunca vio moverse. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        enPantalla = e[0].isIntersecting;
        if (enPantalla) arrancar(); else frenar();
      }, { threshold: 0.25 }).observe(seccion);
    } else { enPantalla = true; arrancar(); }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') arrancar(); else frenar();
    });

    /* Si la persona lo toca, manda ella: se corta para siempre. Un carrusel que
       forcejea con el dedo es peor que uno quieto. */
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      carril.addEventListener(ev, function () { tocado = true; frenar(); }, { passive: true });
    });
    seccion.addEventListener('click', function (e) {
      if (e.target.closest('.circle-button, .scrollbar__buttons')) { tocado = true; frenar(); }
    });
  }

  function empezar() {
    contador();
    /* Nada de carrusel automatico si la persona pidio menos movimiento, ni dentro del
       editor de temas: ahi el tema salta solo al bloque que Emanuel selecciona y un
       timer moviendose le pisa la seleccion. */
    if (editor) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* theme.js es type=module (diferido): sin esto, itemOffset todavia no existe. */
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('scroll-carousel').then(carrusel).catch(function () {});
    } else { carrusel(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', empezar);
  } else { empezar(); }
})();
